import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Calendar from './Calendar';  // Kalender-Komponente
import CustomerForm from './components/CustomerForm'; // Kundenformular
import ProspectList from './components/ProspectList';
import ProspectForm from './components/ProspectForm';

import ItemForm from './components/ItemForm'; // Artikelformular
import ProductGroupList from './components/ProductGroupList'; // Produktgruppen

import MotorTypeForm from './components/MotorTypeForm'; // Motorisierungen
import CustomerList from './components/CustomerList';  // Importiere die CustomerList-Komponente
import ItemList from './components/ItemList'; // ItemList-Komponente
import MachineTypeList from './components/MachineTypeList';
import TypePricingList from './components/TypePricingList'; // Import der TypePricingList-Komponente
import OfferList from './components/OfferList';
import OfferForm from './components/OfferForm';
import NumberSequenceForm from './components/NumberSequenceForm';
import CustomerRentalPricingList from './components/CustomerRentalPricingList';
import CustomerSalesPricingList from './components/CustomerSalesPricingList';
import OrderForm from './components/OrderForm';
import OrderList from './components/OrderList';
import TransportMarkerList from './components/TransportMarkerList';
import TransportMarkerListOrder from './components/TransportMarkerListOrder';
import InvoiceForm from './components/InvoiceForm';
import InvoiceList from './components/InvoiceList';
import AttachmentList from './components/AttachmentList';
import CreditNoteList from './components/CreditNoteList';
import PaymentConditionList from './components/PaymentConditionList';
import AccountingCodeList from './components/AccountingCodeList';
import StorageLocationForm from './components/StorageLocationForm';
import TextBlockForm from './components/TextBlockForm';
import WorkshopOrderForm from './components/WorkshopOrderForm';
import WorkshopOrderList from './components/WorkshopOrderList';
import EmployeeForm from './components/EmployeeForm';
import EmployeeList from './components/EmployeeList';
import TransportForm from './components/TransportForm';
import SubscriptionForm from './components/SubscriptionForm';
import SubscriptionList from './components/SubscriptionList';
import SubscriptionListDueDate from './components/SubscriptionListDueDate';
import GlobalDueSubscriptionNotifier from './components/GlobalDueSubscriptionNotifier'; // Neuer Import
import CompanySetupForm from './components/CompanySetupForm';
import MessageForm from './components/MessageForm';
import MessageTemplateForm from './components/MessageTemplateForm';
import MessageTemplateList from './components/MessageTemplateList';
import ComLogList from './components/ComLogList';
import EmployeeCalendar from './components/EmployeeCalendar';
import RegistrationForm from './components/RegistrationForm'; // Neuer Import
import LoginForm from './components/LoginForm';
import PrivateRoute from './components/PrivateRoute';
import EmployeeTimeLogForm from './components/EmployeeTimeLogForm';
import ServiceMarkerListOrder from './components/ServiceMarkerListOrder';
import api from './services/apiService';
import RevenueForm from './components/RevenueForm';
import FibuExportList from './components/FibuExportList';
import ConditionForm from './components/ConditionForm';
import RoleForm from './components/RoleForm';
import ImportItemForm from './components/ImportItemForm';
import PermissionForm from './components/PermissionForm';
import UserForm from './components/UserForm';
import ImportCustomerForm from './components/ImportCustomerForm';
import ImportContactForm from './components/ImportContactForm';
import HolidayForm from './components/HolidayForm';
import ServiceMarkerForm from './components/ServiceMarkerForm';
import TransportTodayReportForm from './components/TransportTodayReportForm';
import EmployeeTimeLogReport from './components/EmployeeTimeLogReport';
import CustomerCategoryForm from './components/CustomerCategoryForm';
import CustomerGroupForm from './components/CustomerGroupForm';
import CustomerOriginForm from './components/CustomerOriginForm';
import PipelineDefinitionForm    from './components/PipelineDefinitionForm';
import PipelineStageForm         from './components/PipelineStageForm';
import PipelineInstanceForm      from './components/PipelineInstanceForm';
import StageHistoryForm          from './components/StageHistoryForm';
import AssetForm                 from './components/AssetForm';
import ActivityForm              from './components/ActivityForm';
import CrmFollowUpCalendar       from './components/CrmFollowUpCalendar';
import PipelineDocumentLinkForm  from './components/PipelineDocumentLinkForm';
import InterimForm        from './components/InterimForm';
import InterimList       from './components/InterimList';
import BulkMailForm       from './components/BulkMailForm';
import InspectionForm from './components/InspectionForm';
import PaymentForm        from './components/PaymentForm';
import OffersNotOrderedReport from './components/OffersNotOrderedReport';
import OrdersEntryReport from './components/OrdersEntryReport';
import OpenPaymentReport from './components/OpenPaymentReport';
import CustrevFromInvoiceReport from './components/CustrevFromInvoiceReport';
import DashboardReport from './components/DashboardReport';
import RentalCostRevenueReport from './components/RentalCostRevenueReport';
import UVVInspectionList from './components/UVVInspectionList';
import UVVInspectionForm from './components/UVVInspectionForm';
import LwDamageLogList from './components/LwDamageLogList';
import ItemWebChannelSrrList from './components/ItemWebChannelSrrList';
import ItemWebChannelSrrEdit from './components/ItemWebChannelSrrEdit';
import ItemWebChannelLoList from './components/ItemWebChannelLoList';
import ItemWebChannelHpList from './components/ItemWebChannelHpList';
import ItemWebChannelHpEdit from './components/ItemWebChannelHpEdit';
import HpIntegrationSettings from './components/HpIntegrationSettings';
import ItemWebChannelLoEdit from './components/ItemWebChannelLoEdit';
import LoIntegrationSettings from './components/LoIntegrationSettings';
import SrrIntegrationSettings from './components/SrrIntegrationSettings';
import TelematicsProviderForm from './components/TelematicsProviderForm';
import LwUGRNLogList from './components/LwUGRNLogList';


// Importiere den Perms-Hook
import { usePerms } from './hooks/useAuth';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');

    // ✅ Session-Countdown (Restzeit aus JWT exp)
  const [sessionRemainingSec, setSessionRemainingSec] = useState(null);

  function getJwtExpMs(token) {
    try {
      const base64Url = token.split(".")[1];
      if (!base64Url) return null;

      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );

      const payload = JSON.parse(jsonPayload);
      if (!payload?.exp) return null;
      return payload.exp * 1000; // exp ist Sekunden
    } catch {
      return null;
    }
  }

  function formatMMSS(totalSeconds) {
    const s = Math.max(0, Number(totalSeconds || 0));
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}:${String(r).padStart(2, "0")}`;
  }

  // 🔔 Offer-Alarm-Zähler
const [offerAlertCount, setOfferAlertCount] = useState(0);
const POLL_MS = 60_000; // alle 60s aktualisieren

  // Zugriffsfunktion
  const { has, loadPerms } = usePerms();
  

  // Bei jedem Laden der App prüfen wir, ob ein Token vorhanden ist.
  useEffect(() => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      setIsAuthenticated(true);

      // Profil-Daten holen
      api.get('/auth/me')
        .then(response => {
          setUsername(response.data.username);
        })
        .catch(error => {
          console.error('Fehler beim Abrufen des Profils:', error);
        });

      // und Permissions holen
      api.get('/auth/me/permissions')
        .then(response => {
          loadPerms(response.data);   // hier in den Context / Hook einspeisen
        })
        .catch(error => {
          console.error('Fehler beim Abrufen der Permissions:', error);
        });

    } else {
      setIsAuthenticated(false);
    }
      const onLogin = () => {
      const tokenNow = sessionStorage.getItem('accessToken');
      if (!tokenNow) return;

      setIsAuthenticated(true);

      // Profil-Daten holen
      api.get('/auth/me')
        .then(response => setUsername(response.data.username))
        .catch(error => console.error('Fehler beim Abrufen des Profils:', error));

      // Permissions holen
      api.get('/auth/me/permissions')
        .then(response => loadPerms(response.data))
        .catch(error => console.error('Fehler beim Abrufen der Permissions:', error));
    };

    const onLogout = () => {
      setIsAuthenticated(false);
      setUsername('');
      setSessionRemainingSec(null);
    };

    window.addEventListener('auth:login', onLogin);
    window.addEventListener('auth:logout', onLogout);

    return () => {
      window.removeEventListener('auth:login', onLogin);
      window.removeEventListener('auth:logout', onLogout);
    };
  }, []);

    // ✅ Countdown jede Sekunde aktualisieren (Restzeit bis exp)
  useEffect(() => {
    if (!isAuthenticated) {
      setSessionRemainingSec(null);
      return;
    }

    const update = () => {
      const token = sessionStorage.getItem("accessToken");
      const expMs = token ? getJwtExpMs(token) : null;
      if (!token || !expMs) {
        setSessionRemainingSec(null);
        return;
      }

      const diffSec = Math.floor((expMs - Date.now()) / 1000);
      setSessionRemainingSec(diffSec);
    };

    update();
    const id = setInterval(update, 1000);

    return () => clearInterval(id);
  }, [isAuthenticated]);

  // 🔔 Alerts laden (einmalig + Polling)
useEffect(() => {
  if (!isAuthenticated) {
    setOfferAlertCount(0);
    return;
  }

  let stop = false;

  const loadAlerts = async () => {
    try {
      const { data } = await api.get('/offers/bell/alerts');
      if (!stop) setOfferAlertCount(Number(data?.count || 0));
    } catch (e) {
      console.error('Fehler beim Laden der Offer-Alerts:', e);
    }
  };

  // sofort einmal laden
  loadAlerts();

  // Polling
  const id = setInterval(loadAlerts, POLL_MS);

  return () => {
    stop = true;
    clearInterval(id);
  };
}, [isAuthenticated]);

// 🔔 kleines rotes Badge auf der Glocke
const bellBadgeStyle = {
  position: 'absolute',
  top: '-6px',
  right: '-10px',
  background: '#e11',
  color: '#fff',
  borderRadius: '10px',
  padding: '0 6px',
  fontSize: '12px',
  lineHeight: '18px',
  minWidth: 18,
  textAlign: 'center',
};

  const handleLogout = () => {
    sessionStorage.removeItem('accessToken');
    localStorage.removeItem('token');
    delete api.defaults.headers.common.Authorization;
    window.dispatchEvent(new Event('auth:logout'));
    setIsAuthenticated(false);
    setUsername('');
  };

  return (
    <Router>
      <div className="App">
        {/* Globale Benachrichtigung für fällige Subscriptions */}
        {isAuthenticated && <GlobalDueSubscriptionNotifier />}
        
        {/* Navigationsleiste fixiert oben */}
        <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1rem', background: '#f5f5f5' }}>
          <ul className="menu" style={{ listStyle: 'none', display: 'flex', gap: '0rem' }}>
          {has('/calendar') && <li className="menu-item"><Link to="/calendar">Kalender</Link></li>}
          

          
          <li className="menu-item dropdown">
              <Link to="#">Verkauf</Link>
              <ul className="dropdown-content">
              {has('/offers') && <li><Link to="/offers">🏷️ Angebote</Link></li>}
                {has('/orders') && <li><Link to="/orders">📄 Auftrag</Link></li>}
                  {has('/invoices') && <li><Link to="/invoices">💳 Rechnung</Link></li>}
                    {has('/creditnotes') && <li><Link to="/creditnotes">↩️ Gutschrift</Link></li>}
                      {has('/subscriptionlist') && <li><Link to="/subscriptionlist">Aboliste</Link></li>}
                      {has('/subscriptionduedate') && <li><Link to="/subscriptionduedate">fällige Abos</Link></li>}
                      {has('/interims') && <li><Link to="/interims">Zwischenabrechnungen</Link></li>}
                      {has('/transportmarkerlist') && <li><Link to="/transportmarkerlist">Markertest</Link></li>}
              </ul>
            </li> 

            
    <li className="menu-item dropdown">
      <Link to="#">Werkstatt</Link>
      <ul className="dropdown-content">
        {has('/employeetimelogform') && <li><Link to="/employeetimelogform">timelogTest</Link></li>}
        {has('/lw-ugrn')     && <li><Link to="/lw-ugrn">📷 LW UG / RN</Link></li>}
        {has('/lw-damage')     && <li><Link to="/lw-damage">💥 LW Schäden</Link></li>}
        {has('/workshoporders')       && <li><Link to="/workshoporders">🛠️ Werkstattauftrag</Link></li>}
        {has('/employeecalendar')     && <li><Link to="/employeecalendar">🗓️ Servicekalender</Link></li>}
        {has('/uvvInspectionList')     && <li><Link to="/uvvInspectionList">✅ UVV-Berichte</Link></li>}
        
      </ul>
    </li>



    <li className="menu-item dropdown">
      <Link to="#">Kunden</Link>
      <ul className="dropdown-content">
        {has('/customerform')                   && <li><Link to="/customerform">🤵 Kunde neu</Link></li>}
        {has('/customerlist')                   && <li><Link to="/customerlist">📇 Kundenliste</Link></li>}
        {has('/customerrentalpricinglist')     && <li><Link to="/customerrentalpricinglist">💲 Kundentyppreislisten</Link></li>}
        {has('/customersalespricinglist')      && <li><Link to="/customersalespricinglist">💵 Kundenpreislisten</Link></li>}
      </ul>
    </li>
 

           
    <li className="menu-item dropdown">
      <Link to="#">Artikel</Link>
      <ul className="dropdown-content">
        {has('/itemform')      && <li><Link to="/itemform">🎁 Artikel neu</Link></li>}
        {has('/itemlist')      && <li><Link to="/itemlist">🚜 Artikelliste</Link></li>}
        {has('/motor-types')    && <li><Link to="/motor-types">Motorisierung</Link></li>}
        {has('/product-groups') && <li><Link to="/product-groups">Produktgruppen</Link></li>}
        {has('/machine-types')  && <li><Link to="/machine-types">🗂️ Typen</Link></li>}
        {has('/typepricing')    && <li><Link to="/typepricing">💲 Typpreislisten</Link></li>}
      </ul>
    </li>
 


    <li className="menu-item dropdown">
      <Link to="#">Transport</Link>
      <ul className="dropdown-content">
        {has('/transportform') && <li><Link to="/transportform">🚚 Transportplanung</Link></li>}
        
      </ul>
    </li>

    <li className="menu-item dropdown">
      <Link to="#">Listen</Link>
      <ul className="dropdown-content">
        {has('/servicemarkerform') && <li><Link to="/servicemarkerform">🧑 Selbstabholer</Link></li>}
        {has('/transporttodayreportform') && <li><Link to="/transporttodayreportform">🚚 Transporte</Link></li>}
        {has('/employeetimelogreport') && <li><Link to="/employeetimelogreport">🔧 WA-Einsätze</Link></li>}
        {has('/inspectionform') && <li><Link to="/inspectionform">🕵️‍♂️ Prüftermine</Link></li>}
      </ul>
    </li>

    <li className="menu-item dropdown">
      <Link to="#">CRM</Link>
      <ul className="dropdown-content">
        {has('/prospects')                && <li><Link to="/prospects">Interessenten</Link></li>}
        {has('/crmfollowupcalendar')      && <li><Link to="/crmfollowupcalendar">🗓️ Wiedervorlagen</Link></li>}
        {has('/pipelineinstanceform')     && <li><Link to="/pipelineinstanceform">🔥 Vorgänge / Deals</Link></li>}
        {has('/pipelinedefinitionform')   && <li><Link to="/pipelinedefinitionform">📊 Pipeline-Definition</Link></li>}
        {has('/pipelinestageform')        && <li><Link to="/pipelinestageform">🪜 Pipeline-Phasen</Link></li>}
        
        {has('/stagehistoryform')         && <li><Link to="/stagehistoryform">📈 Phasenwechsel-Log</Link></li>}
        {has('/assetform')                && <li><Link to="/assetform">🚜 Bedarfe / Assets</Link></li>}
        {has('/activityform')             && <li><Link to="/activityform">📋 Aktivitäten</Link></li>}
        
        {has('/pipelinedocumentlinkform') && <li><Link to="/pipelinedocumentlinkform">📎 Dokument-Links</Link></li>}
        {has('/bulkmailform') && <li><Link to="/bulkmailform">✉️ DMC</Link></li>}
      </ul>
    </li>



    <li className="menu-item dropdown">
      <Link to="#">Mitarbeiter</Link>
      <ul className="dropdown-content">
        {has('/employeeform') && <li><Link to="/employeeform">👨‍💼👩‍💼 Mitarbeiter neu</Link></li>}
        {has('/employeelist') && <li><Link to="/employeelist">📒 Mitarbeiterliste</Link></li>}
      </ul>
    </li>
    
    <li className="menu-item dropdown">
      <Link to="#">Berichte</Link>
      <ul className="dropdown-content">
        {has('/reports/dashboard') && ( <li><Link to="/reports/dashboard">📊 Dashboard</Link></li>)}
        {has('/reports/payments/open') && ( <li><Link to="/reports/payments/open">📊 Offene Posten</Link></li>)}
        {has('/reports/offers/not-ordered') && ( <li><Link to="/reports/offers/not-ordered">📊 Angebote</Link></li>)}
        {has('/reports/orders/entry') && ( <li><Link to="/reports/orders/entry">📊 Auftrag</Link></li>)}
        {has('/reports/invoices/revenue') && ( <li><Link to="/reports/invoices/revenue">📊 Kunden</Link></li>)}
        {has('/revenueform')          && <li><Link to="/revenueform">📊 Artikel</Link></li>}
        {has('/reports/rental/cost-revenue')          && <li><Link to="/reports/rental/cost-revenue">📊 Artikel Rent</Link></li>}
      </ul>
    </li>

    <li className="menu-item dropdown">
      <Link to="#">Channel</Link>
      <ul className="dropdown-content">
        {has('/itemWebChannelListSRR')          && <li><Link to="/itemWebChannelListSRR"> SmartRentalReady</Link></li>}
        {has('/itemWebChannelListLO')          && <li><Link to="/itemWebChannelListLO"> Liftoutlet</Link></li>}
        {has('/itemWebChannelListHP') && <li><Link to="/itemWebChannelListHP"> Homepage</Link></li>}
      </ul>
    </li>

  

    <li className="menu-item dropdown">
      <Link to="#">
  Einstellungen
  {isAuthenticated && sessionRemainingSec != null && sessionRemainingSec > 0 && (
    <span
      style={{
        marginLeft: 8,
        fontSize: 12,
        padding: "2px 6px",
        borderRadius: 10,
        background: sessionRemainingSec <= 60 ? "#ffd6d6" : "#e9eef6",
      }}
      title="Restzeit bis Session-Ablauf"
    >
      ⏳ {formatMMSS(sessionRemainingSec)}
    </span>
  )}
</Link>
      <ul className="dropdown-content">
        {has('/companysetupform')     && <li><Link to="/companysetupform">Firmeneinstellungen</Link></li>}
        {has('/numbersequenceform')   && <li><Link to="/numbersequenceform">Nummernkreise</Link></li>}
        {has('/attachmentlist')       && <li><Link to="/attachmentlist">📬 Email_Anhang</Link></li>}
        {has('/paymentconditionlist') && <li><Link to="/paymentconditionlist">🤝 Zahlkonditionen</Link></li>}
        {has('/accountingcodelist')   && <li><Link to="/accountingcodelist">🧮 Buchungskonten</Link></li>}
        {has('/storagelocationform')  && <li><Link to="/storagelocationform">🏦 Lagerorte</Link></li>}
        {has('/textblockform')        && <li><Link to="/textblockform">📝 Textbausteine</Link></li>}
        {has('/messageform')          && <li><Link to="/messageform">📰 Nachrichten</Link></li>}
        {has('/messagetemplatelist')  && <li><Link to="/messagetemplatelist">🗃️ Nachrichten-Vorlagen</Link></li>}
        {has('/comloglist')           && <li><Link to="/comloglist">💬 ComLog</Link></li>} 
        {has('/fibuexportlist')       && <li><Link to="/fibuexportlist">🧾 Fibuexport</Link></li>}
        {has('/conditionform')        && <li><Link to="/conditionform">Maschinenzustand</Link></li>}
        {has('/roleform')             && <li><Link to="/roleform">Benutzerrollen</Link></li>}   
        {has('/register')             && <li><Link to="/register">Benutzerregistrierung</Link></li>}   
        {has('/importitemform')       && <li><Link to="/importitemform">Artikelimport LW</Link></li>}      
        {has('/permissionform')       && <li><Link to="/permissionform">Permissions</Link></li>} 
        {has('/userform')             && <li><Link to="/userform">👤 Benutzer</Link></li>}    
        {has('/importcustomerform')   && <li><Link to="/importcustomerform">Kundenimport</Link></li>}  
        {has('/importcontactform')    && <li><Link to="/importcontactform">Contactimport</Link></li>} 
        {has('/holidayform')          && <li><Link to="/holidayform">🌴 Feiertage</Link></li>}
        {has('/customercategoryform') && <li><Link to="/customercategoryform">👷 Kundenkategorie</Link></li>}  
        {has('/customergroupform')    && <li><Link to="/customergroupform">🥇 Kundengruppe</Link></li>}  
        {has('/customeroriginform')   && <li><Link to="/customeroriginform">📢 Herkunft</Link></li>}  
        {has('/paymentform')          && <li><Link to="/paymentform">💰 Zahlungen</Link></li>} 
        {has('/telematicsProviderForm') && <li><Link to="/telematicsProviderForm">Telematik-Hersteller</Link></li>}          
                               {/*        <li><Link to="/roleform">Benutzerrollen</Link></li>    */}
      </ul>
    </li>

  </ul>

        <div className="auth-menu">
            {isAuthenticated ? (
              <>
               {/* 🔔 Glocke (klick führt zu /offers) */}
      {has('/offers') && (
        <Link
          to="/offers"
          title="Offene GPT/Portal-Anfragen"
          style={{ 
            position: 'relative',
            display: 'inline-block',
            marginRight: '12px',
            fontSize: '20px',
            textDecoration: 'none'
          }}
          onClick={() => {
            // Optional: Badge zurücksetzen, wenn man zur Liste geht
            // setOfferAlertCount(0);
          }}
        >
          <span role="img" aria-label="Benachrichtigungen">
            {offerAlertCount > 0 ? '🔔' : '🔕'}
          </span>
          {offerAlertCount > 0 && (
            <span style={bellBadgeStyle}>{offerAlertCount}</span>
          )}
        </Link>
      )}
                <span style={{ marginRight: '1rem', fontSize: '15px' }}>
   {username}
</span>
<span
  onClick={handleLogout}
  style={{ marginRight:'40px', cursor: 'pointer', fontSize: '20px' }}
  title="Logout"
>
⏏️ 
</span>
              </>
            ) : (
              <Link to="/login" style={{ fontSize: '15px', marginRight:'40px', textDecoration: 'none' }}>Login</Link>
            )}
          </div>
        </nav>

        {/* Hauptinhalt */}
        <Routes>
           {/* Öffentliche Routen */}
          <Route path="/login" element={<LoginForm />} />
          
          
         

           {/* Geschützte Routen */}
        <Route element={<PrivateRoute />}>

          {has('/register') &&  <Route path="/register" element={<RegistrationForm />} />}
          {has('/calendar') &&  <Route path="/calendar" element={<Calendar />} />}
          {has('/offers') && <Route path="/offers" element={<OfferList />} />}  
          {has('/orders') && <Route path="/orders" element={<OrderList />} /> }   
          {has('/invoices') &&<Route path="/invoices" element={<InvoiceList />} /> } 
          {has('/creditnotes') && <Route path="/creditnotes" element={<CreditNoteList />} />} 
          {has('/subscriptionlist') && <Route path="/subscriptionlist" element={<SubscriptionList />} />}
          {has('/subscriptionduedate') && <Route path="/subscriptionduedate" element={<SubscriptionListDueDate />} />}
          {has('/workshoporders') && <Route path="/workshoporders" element={<WorkshopOrderList />} />}
          {has('/employeecalendar') && <Route path="/employeecalendar" element={<EmployeeCalendar />} />}
          {has('/customerlist') && <Route path="/customerlist" element={<CustomerList />} />}
          {has('/customerform') && <Route path="/customerform" element={<CustomerForm />} />}
          {has('/prospects') && <Route path="/prospects" element={<ProspectList />} />}
          {has('/prospects') && <Route path="/prospects/new" element={<ProspectForm />} />}
          {has('/prospects') && <Route path="/prospects/:prospectId/edit" element={<ProspectForm />} />}
          {has('/prospects') && <Route path="/prospects/:prospectId/convert" element={<CustomerForm />} />}
          {has('/customerrentalpricinglist') && <Route path="/customerrentalpricinglist" element={<CustomerRentalPricingList />} />}
          {has('/customersalespricinglist') && <Route path="/customersalespricinglist" element={<CustomerSalesPricingList />} />}
          {has('/itemlist') && <Route path="/itemlist" element={<ItemList />} />}
          {has('/itemform') && <Route path="/itemform" element={<ItemForm />} />}
          {has('/product-groups') && <Route path="/product-groups" element={<ProductGroupList />} />}
          {has('/motor-types') && <Route path="/motor-types" element={<MotorTypeForm />} />}
          {has('/machine-types') && <Route path="/machine-types" element={<MachineTypeList />} />}
          {has('/typepricing') && <Route path="/typepricing" element={<TypePricingList />} />}
          {has('/transportform') && <Route path="/transportform" element={<TransportForm />} />}
          {has('/employeelist') && <Route path="/employeelist" element={<EmployeeList />} />}
          {has('/employeeform') && <Route path="/employeeform" element={<EmployeeForm />} />}
          {has('/companysetupform') && <Route path="/companysetupform" element={<CompanySetupForm />} />}
          {has('/numbersequenceform') && <Route path="/numbersequenceform" element={<NumberSequenceForm />} />}
          {has('/attachmentlist') && <Route path="/attachmentlist" element={<AttachmentList />} />}
          {has('/paymentconditionlist') && <Route path="/paymentconditionlist" element={<PaymentConditionList />} />}
          {has('/accountingcodelist') && <Route path="/accountingcodelist" element={<AccountingCodeList />} />}
          {has('/storagelocationform') && <Route path="/storagelocationform" element={<StorageLocationForm />} />}
          {has('/textblockform') && <Route path="/textblockform" element={<TextBlockForm />} />}
          {has('/messagetemplatelist') && <Route path="/messagetemplatelist" element={<MessageTemplateList />} />}
          {has('/messageform') && <Route path="/messageform" element={<MessageForm />} />}
          {has('/comloglist') && <Route path="/comloglist" element={<ComLogList />} />}
          {has('/revenueform') && <Route path="/revenueform" element={<RevenueForm />} />}
          {has('/fibuexportlist') && <Route path="/fibuexportlist" element={<FibuExportList />} />}
          {has('/conditionform') && <Route path="/conditionform" element={<ConditionForm />} />}
          {has('/roleform') && <Route path="/roleform" element={<RoleForm />} />}    
          {has('/importitemform') && <Route path="/importitemform" element={<ImportItemForm />} />} 
          {has('/permissionform') && <Route path="/permissionform" element={<PermissionForm />} />} 
          {has('/userform') && <Route path="/userform" element={<UserForm />} />}     
          {has('/importcustomerform') && <Route path="/importcustomerform" element={<ImportCustomerForm />} />}  
          {has('/importcontactform') && <Route path="/importcontactform" element={<ImportContactForm />} />}
          {has('/holidayform') && <Route path="/holidayform" element={<HolidayForm />} />}    
          {has('/servicemarkerform') && <Route path="/servicemarkerform" element={<ServiceMarkerForm />} />}  
          {has('/transporttodayreportform') && <Route path="/transporttodayreportform" element={<TransportTodayReportForm />} />} 
          {has('/employeetimelogreport') && <Route path="/employeetimelogreport" element={<EmployeeTimeLogReport />} />} 
          {has('/customercategoryform') && <Route path="/customercategoryform" element={<CustomerCategoryForm />} />}  
          {has('/customergroupform') && <Route path="/customergroupform" element={<CustomerGroupForm />} />}  
          {has('/customeroriginform') && <Route path="/customeroriginform" element={<CustomerOriginForm />} />}
          {has('/pipelinedefinitionform')   && <Route path="/pipelinedefinitionform" element={<PipelineDefinitionForm />} />}
          {has('/pipelinestageform')        && <Route path="/pipelinestageform" element={<PipelineStageForm />} />}
          {has('/pipelineinstanceform')     && <Route path="/pipelineinstanceform" element={<PipelineInstanceForm />} />}
          {has('/stagehistoryform')         && <Route path="/stagehistoryform" element={<StageHistoryForm />} />}
          {has('/assetform')                && <Route path="/assetform" element={<AssetForm />} />}
          {has('/activityform')             && <Route path="/activityform" element={<ActivityForm />} />}
          {has('/crmfollowupcalendar')      && <Route path="/crmfollowupcalendar" element={<CrmFollowUpCalendar />} />}
          {has('/pipelinedocumentlinkform') && <Route path="/pipelinedocumentlinkform" element={<PipelineDocumentLinkForm />} />}
          {has('/interims') && (<Route path="/interims" element={<InterimList />} />)}
          {has('/bulkmailform') && (<Route path="/bulkmailform" element={<BulkMailForm />} />)}
          {has('/paymentform') && (<Route path="/paymentform" element={<PaymentForm />} />)}
          {has('/reports/dashboard') && (<Route path="/reports/dashboard" element={<DashboardReport />} />)}
          {has('/reports/offers/not-ordered') && (<Route path="/reports/offers/not-ordered" element={<OffersNotOrderedReport />} />)}
          {has('/reports/orders/entry') && (<Route path="/reports/orders/entry" element={<OrdersEntryReport />} />)}
          {has('/reports/payments/open') && (<Route path="/reports/payments/open" element={<OpenPaymentReport />} />)}
          {has('/reports/invoices/revenue') && (<Route path="/reports/invoices/revenue" element={<CustrevFromInvoiceReport />} />)}
          {has('/reports/rental/cost-revenue') && (<Route path="/reports/rental/cost-revenue" element={<RentalCostRevenueReport />} />)}
          {has('/uvvInspectionList') && (<Route path="uvvInspectionList" element={<UVVInspectionList />} />)}
          {has('/uvvInspectionForm') && (<Route path="/uvvInspectionForm" element={<UVVInspectionForm mode="create" />} />)}
          {has('/lw-damage') && (<Route path="/lw-damage" element={<LwDamageLogList />} />)}
          {has('/itemWebChannelListSRR') && (<Route path="/itemWebChannelListSRR" element={<ItemWebChannelSrrList />} />)}
          {has('/itemWebChannelListLO') && (<Route path="/itemWebChannelListLO" element={<ItemWebChannelLoList />} />)}
          {has('/itemWebChannelListHP') && <Route path="/itemWebChannelListHP" element={<ItemWebChannelHpList />} />}
          {has('/itemWebChannelHP/:itemId/edit') && <Route path="/itemWebChannelHP/:itemId/edit" element={<ItemWebChannelHpEdit />} />}
          {has('/hp-integration') && <Route path="/hp-integration" element={<HpIntegrationSettings />} />}
          {has('/srr-integration') && (<Route path="/srr-integration" element={<SrrIntegrationSettings />} />)}
          {has('/lo-integration') && (<Route path="/lo-integration" element={<LoIntegrationSettings />} />)}
          {has('/telematicsProviderForm') && (<Route path="/telematicsProviderForm" element={<TelematicsProviderForm />} />)}
          {has('/lw-ugrn') && (<Route path="/lw-ugrn" element={<LwUGRNLogList />} />)}
          
             
               {/*                 <Route path="/roleform" element={<RoleForm />} />    */}
          {/* Edit-Routen */}
          {has('/orders/:orderId/transportmarkers') && <Route path="/orders/:orderId/transportmarkers" element={<TransportMarkerListOrder />} />}
          {has('/orders/:orderId/servicemarkers') && <Route path="/orders/:orderId/servicemarkers" element={<ServiceMarkerListOrder />} />}
          {has('/workshoporders/:workshopOrderId/edit') && <Route path="/workshoporders/:workshopOrderId/edit" element={<WorkshopOrderForm mode="edit" />} />}
          {has('/itemform/:itemId') && <Route path="/itemform/:itemId" element={<ItemForm />} />}
          {has('/offers/:offerId/edit') && <Route path="/offers/:offerId/edit" element={<OfferForm mode="edit" />} />}
          {has('/orders/:orderId/edit') && <Route path="/orders/:orderId/edit" element={<OrderForm mode="edit" />} />}
          {has('/invoices/:invoiceId/edit') && <Route path="/invoices/:invoiceId/edit" element={<InvoiceForm mode="edit" />} />}
          {has('/customerform/:customerId') && <Route path="/customerform/:customerId" element={<CustomerForm />} />}
          {has('/interims/:interimId/edit') && ( <Route path="/interims/:interimId/edit" element={<InterimForm mode="edit"/>} /> )}
          {has('/inspectionform') && <Route path="/inspectionform" element={<InspectionForm />} />} 
          {has('/uvvInspectionForm') && (<Route path="/uvv/inspections/:inspectionId/edit" element={<UVVInspectionForm mode="edit" />} />)}
          {has('/itemWebChannelSRR/:itemId/edit') && (<Route path="/itemWebChannelSRR/:itemId/edit"element={<ItemWebChannelSrrEdit mode="edit" />}/>)}
          {has('/itemWebChannelLO/:itemId/edit') && (<Route path="/itemWebChannelLO/:itemId/edit"element={<ItemWebChannelLoEdit mode="edit" />}/>)}

           
          


          <Route path="/employeetimelogform" element={<EmployeeTimeLogForm />} />
          <Route path="/servicemarkerlistorder" element={<ServiceMarkerListOrder />} />
          <Route path="/messagetemplates/new" element={<MessageTemplateForm />} />
          <Route path="/messagetemplates/:id/edit" element={<MessageTemplateForm />} />
          <Route path="/messages/messagetemplates/:id" element={<MessageForm />} />
          <Route path="/subscriptions/:subscriptionId/edit" element={<SubscriptionForm mode="edit" />} />
          <Route path="/employeeform/:employeeId" element={<EmployeeForm />} />
          
          <Route path="/transportmarkerlistorder" element={<TransportMarkerListOrder />} />
          
          <Route path="/transportmarkerlist" element={<TransportMarkerList />} />
          <Route path="/invoices/new" element={<InvoiceForm mode="create" />} />  
          
          
          <Route path="/orders/new" element={<OrderForm mode="create" />} />  
          <Route path="/offers/new" element={<OfferForm mode="create" />} />  

          

          <Route path="/" element={<h2>Willkommen zur Rental App</h2>} />
          <Route path="*" element={<LoginForm />} />   {/* Fallback oder Startseite */}
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default App;
